import { useState, useEffect, createContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CONTENT } from "@/i18n";
import Landing from "@/pages/Landing";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Review from "@/pages/Review";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { Toaster } from "@/components/ui/sonner";

export const AppContext = createContext(null);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/review/:bookingId" element={<Review />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("rpl_lang") || "it");
  const [user, setUser] = useState(null);
  useEffect(() => {
    localStorage.setItem("rpl_lang", lang);
  }, [lang]);
  const t = CONTENT[lang];
  return (
    <AppContext.Provider value={{ lang, setLang, user, setUser, t }}>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </AppContext.Provider>
  );
}

export default App;
